export const EFFECTIVE_AVAILABILITY_SYNC_REASON_VALUES = [
  "appointment-type-updated",
  "provider-availability-updated",
  "room-availability-updated",
] as const;

export type EffectiveAvailabilitySyncReason =
  (typeof EFFECTIVE_AVAILABILITY_SYNC_REASON_VALUES)[number];

/**
 * Collapses upstream scheduling reasons into the reasons accepted by effective-availability sync.
 */
export function normalizeEffectiveAvailabilitySyncReason({
  reason,
}: {
  reason?: string;
}): EffectiveAvailabilitySyncReason {
  switch (reason) {
    case "provider-added":
    case "provider-removed":
    case "provider-availability-updated":
      return "provider-availability-updated";
    case "room-availability-updated":
      return "room-availability-updated";
    default:
      return "appointment-type-updated";
  }
}
